let ConstUtils = {};

let constants = {
  messages: {
    select_dc_error: `Please Select Diagnostics Center. If you are facing trouble booking, please call us on 080-68239341 for assistance. Reference Wellness Id : @arg1`,
    select_city_error: `Please Select City. If you are facing trouble booking, please call us on 080-68239341 for assistance. Reference Wellness Id : @arg1`
  },
  numericals: {
    dc_fetch_count: 5,
    TATA_ER_ID: 313630
  }
}

let extractMessage = (type, args) => {
  let msg = constants.messages[`${type}`];
  if (typeof args == 'string') {
    return msg.replace('@arg1', args);
  } else {
    args.forEach((e, i) => {
      msg = msg.replace(`@arg${i + 1}`, e);
    });
    return msg;
  }
}

const TestDetailsMapping = {
  "MER": {
    "fastingRequired": "No",
    "instructions": ""
  },
  "ME": {
    "fastingRequired": "No",
    "instructions": ""
  },
  "BPB": {
    "fastingRequired": "No",
    "instructions": ""
  },
  
  "BPB-F": {
    "fastingRequired": "Yes",
    "instructions": `This medical test requires you to fast for a minimum of 10-12 hours. You must not consume any food or drinks (except water) for at least 10 - 12 hours prior to the medical test.`
  },
  "CBC": {
    "fastingRequired": "No",
    "instructions": ""
  },
  "HbA1c (Glycosylated Haemoglobin)": {
    "fastingRequired": "No",
    "instructions": ""
  },
  "HBA1C": {
    "fastingRequired": "No",
    "instructions": ""
  },
  "ECG- Resting": {
    "fastingRequired": "No",
    "instructions": `Please wear loose, comfortable clothes like track pants, T-Shirt. Male clients to shave off chest hair prior to the test.`
  },
  "TMT": {
    "fastingRequired": "No",
    "instructions": `TMT process will take 40- 50 minutes. <ul style='margin-left: -23px'><li> Wear loose, comfortable clothes like track pants, T-Shirt, and sports shoes </li> <li> Male clients to shave off chest hair prior to test </li> <li> In case of BP medication kindly consult your physician </li> <li> If client is on (Beta blockers) they are supposed to be paused 24 hrs-48 hrs prior to the test </li> </ul>`
  },
  "2D Echo": {
    "fastingRequired": "No",
    "instructions": `Please wear loose, comfortable clothes like track pants, T-Shirt. Male clients to shave off chest hair prior to test.`
  },
  "USG – Pelvis": {
    "fastingRequired": "Yes",
    "instructions": `<ul style='margin-left: -23px'><li>04 to 06 hours fasting is required, no tea or coffee.</li><li> Only plain water is allowed. </li> <li>Urinary bladder needs to be full, please do not pass urine for 1.5 hrs to 2 hrs prior to the medical test.</li></ul>`
  },
  "USG Whole Abdomen": {
    "fastingRequired": "Yes",
    "instructions": `<ul style='margin-left: -23px'><li>04 to 06 hours fasting is required, no tea or coffee.</li><li> Only plain water is allowed. </li> <li>Urinary bladder needs to be full, please do not pass urine for 1.5 hrs to 2 hrs prior to the medical test.</li></ul>`
  },
  "Chest XRAY": {
    "fastingRequired": "No",
    "instructions": `Please wear loose, comfortable clothes. Do not wear or carry metallic articles.`
  },
  "Anti HCV": {
    "fastingRequired": "No",
    "instructions": ""
  },
  "Urine Microalbumin": {
    "fastingRequired": "No",
    "instructions": ""
  },
  "Alpha Fetoprotein": {
    "fastingRequired": "No",
    "instructions": ""
  },
  "PSA(Prostate Specific Antigen": {
    "fastingRequired": "No",
    "instructions": ""
  },
};

const HVNotConfiguredErIds = [158837];

const AllowedStatusesToBookAppointment = [0,29,30,31,39]; // TODO update booking allowed status ids 

const InsurerLogoMapping = {
  // 313630: "https://telemerclient-assests.docsapp.in/logos/tata-aia.png"
};

const visitTypeEnum = {
  HomeVisit: "Home Visit",
  DcVisist: "DC Visit"
};

const StaticS3ImageUrl = "https://views.medibuddy.in/sal";

ConstUtils.constants = constants;
ConstUtils.extractMessage = extractMessage;
ConstUtils.TestDetailsMapping = TestDetailsMapping;
ConstUtils.HVNotConfiguredErIds = HVNotConfiguredErIds;
ConstUtils.AllowedStatusesToBookAppointment = AllowedStatusesToBookAppointment;

ConstUtils.visitTypeEnum = visitTypeEnum;
ConstUtils.InsurerLogoMapping = InsurerLogoMapping;

ConstUtils.StaticS3ImageUrl = StaticS3ImageUrl;

export default ConstUtils;